import { SectionCard } from '../../../components/ui/SectionCard';
import { AGED_SEGMENTS, fmtAmount } from '../utils';

export function AgedBalanceCard({ stats, locale, t }) {
  const ab = stats?.agedBalance ?? {};
  const total = AGED_SEGMENTS.reduce((s, seg) => s + (ab[seg.key] ?? 0), 0);

  return (
    <SectionCard title="Aged balance">
      <div className="flex rounded-lg overflow-hidden h-[52px] mb-10">
        {AGED_SEGMENTS.map((seg) => {
          const val = ab[seg.key] ?? 0;
          if (!total || !val) return null;
          const pct = (val / total) * 100;
          return (
            <div
              key={seg.key}
              className="flex items-center justify-center transition-all"
              style={{ width: `${pct}%`, backgroundColor: seg.color, minWidth: val > 0 ? 48 : 0 }}
            >
              <span className="text-white text-[11.5px] font-semibold tabular-nums whitespace-nowrap px-2">
                {fmtAmount(val, 'EUR', locale)}
              </span>
            </div>
          );
        })}
        {total === 0 && (
          <div className="flex-1 bg-slate-100 flex items-center justify-center text-[12px] text-slate-400">
            —
          </div>
        )}
      </div>

      <div className="flex gap-6 flex-wrap justify-around">
        {AGED_SEGMENTS.map((seg) => (
          <div key={seg.key} className="flex items-center gap-2">
            <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: seg.color }} />
            <div>
              <p className="text-[11px] text-slate-500">{t(`invoices.${seg.labelKey}`)}</p>
              <p className="text-[12.5px] font-semibold text-slate-800 tabular-nums">
                {fmtAmount(ab[seg.key] ?? 0, 'EUR', locale)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </SectionCard>
  );
}
